import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { createContext, useContext, useState } from "react";
import Home from "./pages/home";
import Login from "./pages/login";
import Register from "./pages/register";
import ForgotPassword from "./pages/forgotpassword";
import ResetPassword from "./pages/resetpassword";
import Dashboard from "./pages/dashboard";
import Template from "./pages/template";
import Chatbot from "./pages/chatbot";
import Profil from "./pages/profil";
import Tentang from "./pages/tentang";
import Bantuan from "./pages/bantuan";
import Kuisioner from "./pages/kuisioner";
import AdminLogin from "./pages/admin-login";
import AdminDashboard from "./pages/admin-dashboard";
import ScrollToTop from "./components/ScrollToTop";
import "./App.css";

/* ══════════════════════════════════════
   AUTH CONTEXT
══════════════════════════════════════ */
export const AuthContext = createContext(null);

export function useAuth() {
  return useContext(AuthContext);
}

function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try {
      const saved = localStorage.getItem("AiDuNodeUser");
      return saved ? JSON.parse(saved) : null;
    } catch {
      return null;
    }
  });

  const login = (userData) => {
    localStorage.setItem("AiDuNodeUser", JSON.stringify(userData));
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem("AiDuNodeUser");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

/* ══════════════════════════════════════
   PROTECTED ROUTE
══════════════════════════════════════ */
function ProtectedRoute({ children }) {
  const { user } = useAuth();
  return user ? children : <Navigate to="/login" replace />;
}

/* ══════════════════════════════════════
   APP
══════════════════════════════════════ */
function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
          <ScrollToTop />
          <Routes>
          {/* Public */}
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />

          {/* Protected — butuh login */}
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/template" element={<ProtectedRoute><Template /></ProtectedRoute>} />
          <Route path="/chatbot" element={<ProtectedRoute><Chatbot /></ProtectedRoute>} />
          <Route path="/profil" element={<ProtectedRoute><Profil /></ProtectedRoute>} />
          <Route path="/tentang" element={<ProtectedRoute><Tentang /></ProtectedRoute>} />
          <Route path="/bantuan" element={<ProtectedRoute><Bantuan /></ProtectedRoute>} />
          <Route path="/kuisioner" element={<ProtectedRoute><Kuisioner /></ProtectedRoute>} />

          {/* Admin */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;